import React, {
  useEffect,
  useRef,
  useState,
} from "react";

import {
  MdKeyboardArrowDown,
  MdLink,
  MdLockOutline,
  
} from "react-icons/md";
import saudiFlag from "../../assets/images/saudi-flag.svg";
import dgaLogoIcon from "../../assets/images/DGA-logo-icon.svg";

import "./GovernmentBanner.css";

const GovernmentBanner = () => {
  const [isExpanded, setIsExpanded] =
    useState(false);

  const panelInnerRef = useRef(null);

  /*
   * Close the expanded panel when Escape
   * is pressed.
   */
  useEffect(() => {
    if (!isExpanded) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsExpanded(false);
      }
    };

    document.addEventListener(
      "keydown",
      handleKeyDown
    );

    return () => {
      document.removeEventListener(
        "keydown",
        handleKeyDown
      );
    };
  }, [isExpanded]);

  /*
   * Measure the real panel height and share it
   * through a global CSS variable.
   *
   * Header and page layout use this variable
   * to move down smoothly.
   */
  useEffect(() => {
    const rootElement =
      document.documentElement;

    const panelElement =
      panelInnerRef.current;

    if (!panelElement) {
      return undefined;
    }

    const updatePanelHeight = () => {
      const panelHeight = isExpanded
        ? panelElement.offsetHeight
        : 0;

      rootElement.style.setProperty(
        "--dga-government-expanded-height",
        `${panelHeight}px`
      );
    };

    const animationFrame =
      window.requestAnimationFrame(
        updatePanelHeight
      );

    let resizeObserver;

    if (
      typeof ResizeObserver !== "undefined"
    ) {
      resizeObserver =
        new ResizeObserver(
          updatePanelHeight
        );

      resizeObserver.observe(panelElement);
    }

    return () => {
      window.cancelAnimationFrame(
        animationFrame
      );

      resizeObserver?.disconnect();
    };
  }, [isExpanded]);

  /*
   * Restore the global offset when this
   * component is removed.
   */
  useEffect(() => {
    return () => {
      document.documentElement.style.setProperty(
        "--dga-government-expanded-height",
        "0px"
      );
    };
  }, []);

  const handleToggle = () => {
    setIsExpanded(
      (currentValue) => !currentValue
    );
  };

  return (
    <></>
    // <div
    //   className={[
    //     "dga-government-banner",
    //     isExpanded
    //       ? "dga-government-banner--expanded"
    //       : "",
    //   ]
    //     .filter(Boolean)
    //     .join(" ")}
    // >
    //   <div className="dga-government-banner__content">
    //     <span className="dga-government-banner__flag">
    //       <img
    //         src={saudiFlag}
    //         alt="علم المملكة العربية السعودية"
    //         className="dga-government-banner__flag-image"
    //       />
    //     </span>        

    //     <span className="dga-government-banner__text">
    //       موقع حكومي مسجل لدى هيئة الحكومة
    //       الرقمية
    //     </span>

    //     <button
    //       type="button"
    //       className="dga-government-banner__verification"
    //       onClick={handleToggle}
    //       aria-expanded={isExpanded}
    //       aria-controls="government-verification-panel"
    //     >
    //       <span>كيف تتحقق؟</span>

    //       <MdKeyboardArrowDown
    //         className="dga-government-banner__arrow"
    //         aria-hidden="true"
    //       />
    //     </button>
    //   </div>

    //   <div
    //     id="government-verification-panel"
    //     className="dga-government-banner__panel"
    //     aria-hidden={!isExpanded}
    //   >
    //     <div
    //       ref={panelInnerRef}
    //       className="dga-government-banner__panel-inner"
    //     >
    //       <div className="dga-government-banner__verification-grid">
    //         <VerificationItem
    //           icon={<MdLink />}
    //           title={
    //             <>
    //               روابط المواقع الإلكترونية
    //               الرسمية السعودية تنتهي بـ{" "}
    //               <strong>org.sa</strong>
    //             </>
    //           }
    //         >
    //           <span className="dga-government-banner__verification-text">
    //           جميع روابط المواقع الرسمية
    //           للمؤسسات غير الربحية في المملكة
    //           العربية السعودية تنتهي بـ{" "}
    //           <strong>org.sa</strong>
    //           </span>
    //         </VerificationItem>

    //         <VerificationItem
    //           icon={<MdLockOutline />}
    //           title={
    //             <>
    //               المواقع الإلكترونية الحكومية
    //               تستخدم بروتوكول{" "}
    //               <strong>HTTPS</strong>{" "}
    //               للتشفير والأمان
    //             </>
    //           }
    //         >
    //           <span className="dga-government-banner__verification-text">
    //           المواقع الإلكترونية الآمنة في
    //           المملكة العربية السعودية تستخدم
    //           بروتوكول{" "}
    //           <strong>HTTPS</strong>{" "}
    //           للتشفير.
    //           </span>
    //         </VerificationItem>
    //       </div>

    //       <div className="dga-government-banner__registration">
    //         <img
    //           src={dgaLogoIcon}
    //           alt="شعار هيئة الحكومة الرقمية"
    //           className="dga-government-banner__registration-icon"
    //         />

    //         <span className="dga-government-banner__registration-text">
    //           مسجل لدى هيئة الحكومة الرقمية برقم:
    //         </span>

    //         <span className="dga-government-banner__registration-number">
    //           <a
    //               className="dga-government-banner__registration-number"
    //               href="https://raqmi.dga.gov.sa/platforms/platforms/d19ef875-3359-4f5f-8b10-fc84caf339dd/platform-license"
    //               target="_blank"
    //               rel="noopener noreferrer"
    //             >
    //               20260606461
    //             </a>
    //         </span>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

const VerificationItem = ({
  icon,
  title,
  children,
}) => {
  return (
    <></>
    // <section className="dga-government-banner__verification-item">
    //   <span
    //     className="dga-government-banner__verification-icon"
    //     aria-hidden="true"
    //   >
    //     {icon}
    //   </span>

    //   <div className="dga-government-banner__verification-information">
    //     <h2 className="dga-government-banner__verification-title">
    //       {title}
    //     </h2>

    //     <p className="dga-government-banner__verification-description">
    //       {children}
    //     </p>
    //   </div>
    // </section>
  );
};

export default GovernmentBanner;